export type { RegistrationFormProps } from "./RegistrationForm";
export { RegistrationForm } from "./RegistrationForm";
